import { memo } from 'react';
import { Button } from '@mui/material';
import { Login } from '@mui/icons-material';
import { areClassNamePropsEqual } from '../utilities/utils';

const SignInButton = ({ className, loginCallback }: { className?: string, loginCallback?: () => void }): JSX.Element => {
    return (
        <Button variant="contained" color="primary" className={`${className} navActionButton`}
            data-targetid="votes"
            title="Sign in to tarlings to view your session"
            onClick={() => {
                if (loginCallback) loginCallback();
            }}>
            <span className="navButtonText">
                <Login fontSize='medium' />
                {'Log In '}
            </span>
        </Button>
    )
};

export default memo(SignInButton, areClassNamePropsEqual);
